import { UserRoles } from '@/app/constants/user-roles';
import { moduleActionContext } from '@/app/store';
import { defineModule } from 'direct-vuex';
import { clone, includes, isNil } from 'ramda';

export interface AuthState {
    user: any;
    isKeycloakInitialised: boolean;
}

const authModule = defineModule({
    namespaced: true,
    state: (): AuthState => {
        return {
            user: null,
            isKeycloakInitialised: false,
        };
    },
    mutations: {
        CLEAR_USER(state: AuthState) {
            state.user = null;
        },
        SET_USER(state: AuthState, newUser: any) {
            state.user = clone(newUser);
        },
        SET_KEYCLOAK(state: AuthState, value: boolean) {
            state.isKeycloakInitialised = value;
        },
    },
    getters: {
        isAuthenticated: (state: AuthState) => !!state.user,
        hasRole: (state: AuthState) => (role: UserRoles) =>
            !isNil(state.user.roles) && includes(role, state.user.roles),
    },
});

export default authModule;
export const authModuleActionContext = (context: any) => moduleActionContext(context, authModule);
